import Vue from "vue"
import App from "./App.vue"
// 一个现代化的重置css
import "normalize.css/normalize.css"

// 路由
import router from "./router"

// 引入 element-ui
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI, { size: "mini" })

// 统一引入样式
import "@/styles/index.scss"
// 统一注册全局组件
import AuComponents from "@/components/index.js"
Vue.use(AuComponents)
import waterfall from "vue-waterfall2"
Vue.use(waterfall)

// 引入原型方法
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs
import { cloneDeep } from "lodash"
Vue.prototype.$cloneDeep = cloneDeep
import * as Cache from "@/utils/cache"
Vue.prototype.$cache = Cache

Vue.config.productionTip = false

// 拓展一个数字的原型方法，统一使用 my 开头作为标识，用于避免潜在冲突
/*eslint no-extend-native: ["error", { "exceptions": ["Number"] }]*/
Number.prototype.myFixed = function (digit = 2) {
  return Number(this.toFixed(digit))
}

new Vue({
  el: "#app",
  router,
  render: h => h(App)
})
